import { Injectable, inject } from '@angular/core';
import { Observable, tap, catchError, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse  } from '@angular/common/http';
import { appsettings } from '../settings/appsettings';

@Injectable({
  providedIn: 'root'
})
export class PlanificacionService {

  constructor() { }

  private http = inject(HttpClient);
  private url = appsettings.apiUrl;

  //-----  Funciones de busqueda  -----

  buscarRecursivamente(array: any[], nombre: string): any[] {
    const resultados: any[] = [];
    function buscar(items: any[]) {
      for (const item of items) {
        //console.log('prueba siii:   ',item)
        if (item.organizacion && item.organizacion.toLowerCase().includes(nombre.toLowerCase())) {
          //console.log('prueba siii:   ',item)
          resultados.push(item);
        }
        if (item.hijos && item.hijos.length > 0) {
          console.log('prueba nooo:   ',item)
          buscar(item.hijos);
        }
      }
    }
    buscar(array);
    return resultados;
  }

  eliminarDuplicadosEnTodoArray(array: any[]): any[] {
    const seen = new Map<string, any>(); // Mapa para rastrear objetos únicos por codigo_of
    const nuevoArray = array.map(item => {
      const uniqueValue: any[] = [];
      item.value.forEach((obj: any) => {
        if (!seen.has(obj.codigo_of)) {
          seen.set(obj.codigo_of, obj); // Guardamos el objeto completo por si acaso
          uniqueValue.push(obj);
        }
      });
      return { ...item, value: uniqueValue };
    });
    return nuevoArray;
  }

  identificarDuplicadosEnTodoArray(array: any[]): any[] {
    const seen = new Map<string, boolean>(); // Mapa para rastrear si el codigo_of ya se vio
    return array.map(item => ({...item,
      value: item.value.map((obj:any) => {
        const esDuplicado = seen.has(obj.codigo_of);
        seen.set(obj.codigo_of, true); // Marcamos el codigo_of como visto
        return { ...obj, esDuplicado };
      })
    }));
  }

  moverObjeto180AlPrincipio(arr: { key: string; value: any[] }[]): { key: string; value: any[] }[] {
    const objeto180 = arr.find(item => item.key === '180');
    if (objeto180) {
      // Filtra el arreglo original para excluir el objeto con key "180"
      const otrosObjetos = arr.filter(item => item.key !== '180');
      // Crea un nuevo arreglo con el objeto "180" al principio y luego los demás
      return [objeto180, ...otrosObjetos];
    }
    // Si no se encuentra el objeto con key "180", devuelve el arreglo original sin cambios
    return arr;
  }

  //-----  Fin de funciones  -----

  planificacion(id: string, year: string): Observable<any> {
    const url = `${this.url}/planification/get/${id}/${year}`; // URL completa en una variable para claridad
    return this.http.get<any>(url).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }

  listarAmbito(id: string, year: string): Observable<any> {
    const url = `${this.url}/planification/get/ambitos/${id}/${year}`; // URL completa en una variable para claridad
    return this.http.get<any>(url).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }


  listarOrganizacion(id: string, year: string, id_ambito: string, tipo: string, id_org: any): Observable<any> {
    const url = `${this.url}/planification/get/organizaciones/${id}/${year}/${id_ambito}/${tipo}/${id_org}`; // URL completa en una variable para claridad
    return this.http.get<any>(url).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }

  listarOrganizaciones(id: string, year: string, id_ambito: string, tipo: string): Observable<any> {
    const url = `${this.url}/planification/listar_organizaciones/${id}/${year}/${id_ambito}/${tipo}`; // URL completa en una variable para claridad
    return this.http.get<any>(url).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }

  listarOcuopacion(id_rol: string): Observable<any> {
    const url = `${this.url}/planification/listar_ocupaciones/${id_rol}`; // URL completa en una variable para claridad
    return this.http.get<any>(url).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }


  listarPerfil(id_ocupacion: string): Observable<any> {
    const url = `${this.url}/planification/listar_perfiles/${id_ocupacion}`; // URL completa en una variable para claridad
    return this.http.get<any>(url).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }


  listarOferta(id_perfil_productivo: string): Observable<any> {
    const url = `${this.url}/planification/listar_oferta/${id_perfil_productivo}`; // URL completa en una variable para claridad
    return this.http.get<any>(url).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }

  listarFormador(objeto: object):Observable<any>{
    const url = `${this.url}/planification/listar_formador`; // URL completa en una variable para claridad
    return this.http.post<any>(url, objeto).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }

  createAccionFormativa(objeto: object):Observable<any>{
    const url = `${this.url}/planification/crear/accionFormativa`; // URL completa en una variable para claridad
    return this.http.post<any>(url, objeto).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }






}
